const ConfirmActionModal = ({
  isOpen,
  onClose,
  onConfirm,
  ids,
  entityName = "item",
  title = "Are you sure?",
  message,
  confirmText = "Confirm",
  cancelText = "Cancel",
}) => {
  if (!isOpen) return null;

  const isBulk = Array.isArray(ids) && ids.length > 1;
  const defaultMessage = isBulk
    ? `Do you really want to confirm ${ids.length} ${entityName}s?`
    : `Do you really want to confirm this ${entityName}?`;
  const displayMessage = message || defaultMessage;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40">
      <div className="bg-white rounded-lg shadow-lg p-6 w-96">
        <h2 className="text-xl font-bold mb-4 text-gray-700">{title}</h2>
        <p className="text-gray-600 mb-6">{displayMessage}</p>
        <div className="flex justify-end gap-3">
          <button
            onClick={onClose}
            className="bg-[#E7633D]/90 text-sm text-white py-2 px-6 rounded-md hover:bg-[#E7633D] transition-all duration-300"
          >
            {cancelText}
          </button>
          <button
            onClick={() => {
              onConfirm(ids);
              onClose();
            }}
            className="bg-M-primary-color/90 text-sm text-white py-2 px-6 rounded-md hover:bg-M-primary-color transition-all duration-200"
          >
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmActionModal;